import React from 'react';
import {connect} from 'react-redux';
import {navigateToStep} from "../../actions/join/joinActions";
import {JoinSteps, JoinStepsDirections, JoinCreateAccountConstants, FetchingTypes, PaymentMethod, MemberActions} from "../../common/constants";
import {getJoinSelectedItems} from "../../common/basket";
import {isFetching} from "../../actions/common/fetchingActions";
import {Button} from "react-bootstrap";
import {translate} from '../../i18n/translate.js';
import styles from '../../css/join/JoinNavigationButtons.less';

class JoinNavigationButtons extends React.Component {
    nextClicked = () => {
        this.props.navigateToStep(JoinStepsDirections.NEXT);
    };

    backClicked = () => {
        this.props.navigateToStep(JoinStepsDirections.BACK);
    };

    render() {
        const showArrow = this.props.buttonsState.nextText === translate("Next");
        const nextClassName = "navigation-btn" + (showArrow ? " show-arrow" : "") + (this.props.isProcessing ? " button loading" : "");
        return (
            <div className="join-navigation-header">
                <span className="join-navigation-next">
                    <Button bsStyle="primary" className={nextClassName} hidden={!this.props.buttonsState.nextVisible}
                            disabled={!this.props.buttonsState.nextEnabled} onClick={this.nextClicked}>
                        {this.props.buttonsState.nextText}
                    </Button>
                </span>
                {this.props.children ?
                    this.props.children
                    : undefined
                }
                <span className="join-navigation-back">
                    <Button bsStyle="primary" className="navigation-btn" hidden={!this.props.buttonsState.backVisible}
                            disabled={!this.props.buttonsState.backEnabled} onClick={this.backClicked}>{translate("Back")}</Button>
                </span>
            </div>)
    }
}

const getButtonsState = (signupData, summary, isProcessing, staticData) => {
    let backVisible = false;
    let backEnabled = true;
    let nextVisible = true;
    let nextEnabled = false;
    let nextText = translate("Next");
    const selectedData = (signupData.selectedData || {});
    switch (signupData.step) {
        case (JoinSteps.PICKUP_SITES):
            backEnabled = backVisible = signupData.isGuestUser;
            nextEnabled = summary.pickupSite !== undefined && summary.pickupSite !== null && !summary.isCreatingSubscription;
            if(signupData.isGuestUser) {
                nextText = translate("SHOP");
            }
            break;
        case (JoinSteps.SHARES):
            const isWaitList = (signupData.data || {}).isWaitListOnly;
            backVisible = !isWaitList;
            const selectedShares =  getJoinSelectedItems(signupData.sharesData.shares, {});
            const items = !isWaitList?selectedShares.items:selectedShares.waitlistItems;
            //In add subscription can skip selecting shares
            if (signupData.isAddSubscription && (signupData.data || {}).hasOptions)
                nextEnabled = true;
            else
                nextEnabled = items.length > 0;
            break;
        case (JoinSteps.OPTIONS):
            backVisible = true;
            //In add subscription can skip selecting shares
            if (signupData.isAddSubscription)
                nextEnabled = getJoinSelectedItems(signupData.sharesData.shares, signupData.sharesData.options).items.length > 0;
            else
                nextEnabled = true;
            break;
        case (JoinSteps.TERMS):
            backVisible = true;
            nextEnabled = selectedData.selectedPaymentPlan !== undefined;
            break;
        case (JoinSteps.CONTACT_INFO):
            backVisible = true;
            nextEnabled = !isProcessing && signupData.contactInfoPage === JoinCreateAccountConstants.CONTACT_DETAILS;
            backEnabled = !isProcessing;
            nextVisible = signupData.contactInfoPage === JoinCreateAccountConstants.CONTACT_DETAILS;
            if((signupData.data || {}).isWaitListOnly) {
                nextText = translate("Finish");
            }
            break;
        case (JoinSteps.PAY):
            backVisible = true;
            nextEnabled = !isProcessing && selectedData.selectedMethod !== undefined && selectedData.selectedMethod !== PaymentMethod.NONE.key &&
                (selectedData.termsSelected || staticData.joinTermsAgreement);
            if (staticData.mandatorySignupComments && !selectedData.signupComments) {
                nextEnabled = false;
            }
            nextText = translate("Checkout");
            backEnabled = !isProcessing;
            break;
    }
    return {backVisible, backEnabled, nextVisible, nextEnabled, nextText};
};

const mapStateToProps =  (state) =>  {
    const signupData = (state.signupData || {});
    const summary = (state.summary || {});
    const isProcessing = isFetching(state, FetchingTypes.SUBMIT)
        || isFetching(state, FetchingTypes.VALIDATE_UPDATE_MEMBER)
        || state.memberDetails.memberAction === MemberActions.VALIDATE_MEMBER_DETAILS;
    return {
        staticData: state.staticData,
        signupData: signupData,
        summary: summary,
        isProcessing: isProcessing,
        buttonsState: getButtonsState(signupData, summary, isProcessing, state.staticData)
    }
};

const mapDispatchToProps =  (dispatch) => {
    return {
        navigateToStep: (direction) => {
            dispatch(navigateToStep(direction));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(JoinNavigationButtons);


// WEBPACK FOOTER //
// ./src/containers/join/JoinNavigationButtons.js